import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { Lightbulb } from '@liveauctioneers/hammer-ui-core/icons';
import FormattedMessageText from '@/components/Formatted/FormattedMessageText';

type Props = {
    className?: string;
    messageId: string;
    variant?: 'default' | 'embedded';
};

const variantStyles = {
    default: 'rounded-lg border border-border-secondary',
    embedded: 'items-start rounded-b-lg border-x-0 border-t border-border-secondary rounded-t-none',
};

export const ProTip = ({ className, messageId, variant = 'default' }: Props) => (
    <div className={cn('flex gap-xs bg-background-info-light p-sm', variantStyles[variant], className)}>
        <Lightbulb
            color="info"
            size="sm"
            style="fill"
        />
        <BodyPrimary className="text-text-primary">
            <FormattedMessageText id={messageId} />
        </BodyPrimary>
    </div>
);
